/** @jsxImportSource @emotion/react */
import { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { urlBaseAPI } from "../../utils";

export const EXTENSIONES_IMAGEN = ["png", "jpg", "jpeg", "gif", "webp", "svg"];
// Las planillas las convierte la API a PDF al vuelo para la vista previa
const EXTENSIONES_PLANILLA = ["xlsx", "xls", "csv", "ods"];
const EXTENSIONES_SOPORTADAS = [
  "pdf",
  "txt",
  ...EXTENSIONES_IMAGEN,
  ...EXTENSIONES_PLANILLA,
];

export function obtenerExtension(nombre) {
  if (!nombre) return "";
  return nombre.split(".").pop().toLowerCase();
}

/**
 * Diálogo con la vista previa de un archivo, controlado desde afuera
 * (`visible` / `onHide`). Lo usa ArchivoPreview al hacer clic en su link, y
 * sirve para abrir la vista previa desde un menú o un botón.
 *
 * El archivo se sirve por su hash (ruta pública de preview), así que funciona
 * igual desde cualquier plataforma.
 */
export default function VisorArchivo({
  visible,
  onHide,
  nombre,
  hash,
  titulo,
  sinToolbar,
}) {
  // Loader hasta que el iframe termina de cargar (para las planillas eso
  // incluye la conversión a PDF en el servidor)
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    if (visible) setCargando(true);
  }, [visible, hash]);

  const extension = obtenerExtension(nombre);
  const esImagen = EXTENSIONES_IMAGEN.includes(extension);
  const soportado = EXTENSIONES_SOPORTADAS.includes(extension);
  const previewUrl = `${urlBaseAPI()}/archivo/${hash}/preview${
    !esImagen && sinToolbar ? "#toolbar=0" : ""
  }`;

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header={titulo || nombre || "Archivo"}
      maximizable
      style={{ width: "80vw", height: "80vh" }}
      contentStyle={{ padding: 0, overflow: "hidden", height: "100%" }}
    >
      {!hash || !soportado ? (
        <div
          css={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            color: "#888",
            fontSize: "1.1em",
          }}
        >
          Vista previa no disponible para este tipo de archivo
        </div>
      ) : esImagen ? (
        <div
          css={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            padding: "1rem",
          }}
        >
          {visible && (
            <img
              src={previewUrl}
              alt={nombre}
              css={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
            />
          )}
        </div>
      ) : (
        <div css={{ position: "relative", height: "100%" }}>
          {cargando && (
            <div
              css={{
                position: "absolute",
                inset: 0,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "1em",
                color: "var(--grisTextos, #888)",
              }}
            >
              <i className="pi pi-spin pi-spinner" css={{ fontSize: "2.5em" }}></i>
              Preparando vista previa...
            </div>
          )}
          {visible && (
            <iframe
              src={previewUrl}
              title={nombre}
              onLoad={() => setCargando(false)}
              style={{
                width: "100%",
                height: "100%",
                border: "none",
                visibility: cargando ? "hidden" : "visible",
              }}
            />
          )}
        </div>
      )}
    </Dialog>
  );
}
